import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import IconButton from '@mui/material/IconButton';
import DataObjectIcon from '@mui/icons-material/DataObject';

import { amber } from '@mui/material/colors';

import TooltipOnCursor from 'components/Shared/TooltipOnCursor';
import JsonViewerDialog from 'components/Shared/JsonViewerDialog';
import GeswebLink from 'components/Shared/GeswebLink';
import WarningReclamationDialog from './WarningReclamationDialog';

import { Modeslivraison, StatutPieceDuJour } from 'constants.js';

import dateHelper from 'utils/dateHelper';


const styles = theme => ({
    row: {
        flexBasis: '100%'
    },
    // rootTableNormal: {
    //     width: '100%',
    //     height: '200px',
    //     overflowX: 'auto',
    //     overFlowY: 'auto'
    // },
    // rootTableHigh: {
    //     width: '100%',
    //     height: '300px',
    //     overflowX: 'auto',
    //     overFlowY: 'auto'
    // },
    messageTableCell: {
        backgroundColor: amber[700],
        color: theme.palette.common.white
    },

    rowStriped: {

        // https://stripesgenerator.com/stripe/4974

        backgroundImage: "linear-gradient(135deg, #f5f5f5 25%, #eff0eb 25%, #eff0eb 50%, #f5f5f5 50%, #f5f5f5 75%, #eff0eb 75%, #eff0eb 100%);",
        backgroundSize: "56.57px 56.57px;"
    },
});

class PieceGestionSearchResult extends React.Component {
    state = {
        selectedPiece: '',
        warningReclamationIds: [],
        warningLivraison: false,
        warningLivraisonMessage: '',
        warningCommandeLD: false,
        warningCommandeLDMessage: '',
        jsonDialogOpen: false,
        jsonDialogPiece: null
    };

    handleClick = (event, numeroPiece, reclamationIds, dateLivraison) => {
        const { onSelectPiece, warningReclamation, warningLivraison, warningCommandeLivraisonDirecte } = this.props;
        const { selectedPiece } = this.state;

        onSelectPiece(selectedPiece, numeroPiece);

        let livraisonAujourdhui = dateHelper.aujourdhui(dateLivraison);
        let livraisonHierEtMatin = dateHelper.hier(dateLivraison) && dateHelper.matin(new Date());

        let warningLivraisonRecente = warningLivraison && (livraisonAujourdhui || livraisonHierEtMatin);

        let warningLivraisonMessage = '';
        if (warningLivraisonRecente) {
            if (livraisonAujourdhui) {
                warningLivraisonMessage = `Vous effectuez un dossier après-vente sur une pièce expédiée aujourd'hui,
                pour rappel des contrats de livraison Foussier:
                <br/>
                <ul>  
                    <li>TNT peut livrer jusqu'à 13 heures</li>
                    <li>Chronpost peut livrer jusqu'à 14 heures</li>
                    <li>les messagers livrent sous 48 heures</li>
                </ul>
                Merci de prendre en compte de ces paramètres avant de poursuivre votre dossier après-vente.`;
            }
            else { // livraisonHierEtMatin
                warningLivraisonMessage = `Vous effectuez un dossier après-vente sur une pièce expédiée hier,
                pour rappel des contrats de livraison Foussier:
                <br/>
                <ul>  
                    <li>TNT peut livrer jusqu'à 13 heures</li>
                    <li>Chronpost peut livrer jusqu'à 14 heures</li>
                    <li>les messagers livrent sous 48 heures</li>
                </ul>
                Merci de prendre en compte ces paramètres avant de poursuivre votre dossier après-vente.`;
            }
        }

        let warningCommandeLivraisonDirecteMessage =
            `Cette commande est une commande en livraison directe de notre fournisseur.<br/>
            Elle ne peut donc pas être retournée sans validation du fournisseur.<br/>
            Le retour plateforme n'est pas autorisé.<br/>
            Le dossier après-vente sera affecté au sédentaire du client.`;


        this.setState({
            selectedPiece: numeroPiece,
            warningReclamationIds: warningReclamation ? reclamationIds : [],
            warningLivraison: warningLivraisonRecente,
            warningLivraisonMessage: warningLivraisonMessage,
            warningCommandeLD: warningCommandeLivraisonDirecte,
            warningCommandeLDMessage: warningCommandeLivraisonDirecteMessage
        });

    }

    handleIgnoreWarning = () => {
        this.setState({
            warningReclamationIds: []
        });
    }

    handleIgnoreWarningLivraison = () => {
        this.setState({
            warningLivraison: false,
            warningLivraisonMessage: ''
        });
    }

    handleIgnoreWarningCommandeLivraisonDirecte = () => {
        this.setState({
            warningCommandeLD: false,
            warningCommandeLDMessage: ''
        });
    }

    handleWarningCancel = () => {
        this.setState({
            warningReclamationIds: [],
            warningLivraison: false,
            warningCommandeLD: false
        });

        this.props.warningCancel();
    }

    handleOpenJsonDialog = (event, piece) => {
        event.stopPropagation();
        this.setState({ jsonDialogOpen: true, jsonDialogPiece: piece });
    }

    handleCloseJsonDialog = () => {
        this.setState({ jsonDialogOpen: false, jsonDialogPiece: null });
    }

    isSelected = numeroPiece => this.state.selectedPiece === numeroPiece;

    renderMessage() {
        const { classes, piecesGestion, afterSearch, afficheApplication, afficheJson } = this.props;

        const baseColSpan = 9 + (afficheApplication ? 1 : 0) + (afficheJson ? 1 : 0);

        if (piecesGestion) {

            if (piecesGestion.length > 100) {
                return (
                    <TableRow>
                        <TableCell className={classes.messageTableCell} colSpan={baseColSpan} >
                            <Typography variant="inherit">Nombre de résultats trop important, affichage des 100 premiers éléments uniquement.</Typography>
                        </TableCell>
                    </TableRow>
                );
            }
            else {
                if (afterSearch && piecesGestion.length === 0) {
                    return (
                        <TableRow>
                            <TableCell className={classes.messageTableCell} colSpan={baseColSpan}>
                                <Typography variant="inherit">Aucun résultat trouvé.</Typography>
                            </TableCell>
                        </TableRow>
                    );
                }
            }
        }

        return (null);
    }

    renderRows() {
        const { classes, piecesGestion, filterIMM30, disableToutesLignesNulles, afficheApplication, afficheJson, disableMixLignesPositivesNegatives, autoriserToutePieceDuJour } = this.props;

        if (piecesGestion) {

            let size = piecesGestion.length > 100 ? 100 : piecesGestion.length;

            return (
                piecesGestion.slice(0, size).map(p => {
                    const isSelected = this.isSelected(p.numeroPiece);

                    let autoriseClick = true;
                    let estPieceDuJourGrisee = false;
                    let title = null;

                    if (p.statutPieceDuJour === StatutPieceDuJour.DuJourIndisponible) {
                        estPieceDuJourGrisee = true;
                        title = "Pièce en départ ce jour";
                        if (!autoriserToutePieceDuJour) {
                            autoriseClick = false;
                        }
                    }
                    else if (filterIMM30 && (p.modeLivraison !== Modeslivraison.IMM || dateHelper.age(p.dateLivraison) <= 30)) {
                        autoriseClick = false;
                        title = "Cette pièce n'est pas autorisée pour cette qualification, veuillez vérifier le mode de livraison de la pièce (IMM) ou sa date de livraison qui doit être supérieure à 30 jours.";
                    }
                    else if (disableToutesLignesNulles && p.toutesLignesNulles) {
                        autoriseClick = false;
                        title = "Toutes les quantités de la pièce sont à 0, cette pièce ne peut donner lieu à un dossier après-vente. L'article que vous recherchez se trouve sur une autre pièce.";
                    }
                    else if (disableMixLignesPositivesNegatives && p.mixLignesPositivesNegatives) {
                        autoriseClick = false;
                        title = "Cette pièce ne peut faire l'objet d'un dossier après-vente sur cette catégorie.";
                    }
                    else if (p.caPieceGroupe < 0) {
                        autoriseClick = false;
                        title = "Il s'agit d'une pièce de type avoir, la création d'un dossier n'est pas autorisée.";
                    }
                    else if (p.pieceRapidoNonExpediee) {
                        autoriseClick = false;
                        title = "Pièce Rapido non expediée !";
                    }

                    return (
                        <TooltipOnCursor
                            key={p.numeroPiece}
                            title={title}
                        >
                            < TableRow
                                hover
                                onClick={autoriseClick ? event => this.handleClick(event, p.numeroPiece, p.reclamationIds, p.dateLivraison) : null}
                                selected={isSelected}
                                className={(!autoriseClick || estPieceDuJourGrisee) ? classes.rowStriped : undefined}
                            >
                                <TableCell component="th" scope="row">
                                    {p.bonLivraisonGestionCle ? (
                                        <span onClick={e => e.stopPropagation()} title="Ouvrir la pièce (LIV) dans GesWeb">
                                            <GeswebLink mode="button" label={p.numeroPiece} structure="bonlivraison" cle={p.bonLivraisonGestionCle} iconPosition="before" />
                                        </span>
                                    ) : p.numeroPiece}
                                </TableCell>
                                <TableCell>{p.numeroPreparation}</TableCell>
                                <TableCell>
                                    {p.commandeGestionCle ? (
                                        <span onClick={e => e.stopPropagation()} title="Ouvrir la commande d'origine dans GesWeb">
                                            <GeswebLink mode="button" label={p.commandeOrigine} structure="commande" cle={p.commandeGestionCle} iconPosition="before" />
                                        </span>
                                    ) : p.commandeOrigine}
                                </TableCell>
                                <TableCell>{p.referenceCommande}</TableCell>
                                <TableCell>{p.codeDepot}</TableCell>
                                <TableCell>{p.nbLignesArticle}</TableCell>
                                <TableCell>{p.transporteur}</TableCell>
                                <TableCell>{p.dateLivraison ? new Date(p.dateLivraison).toLocaleDateString() : ''}</TableCell>
                                <TableCell>{p.dateCreation ? new Date(p.dateCreation).toLocaleDateString() : ''}</TableCell>
                                {afficheApplication && (<TableCell>{p.applicationOrigine ? 'G' : ''}</TableCell>)}
                                {afficheJson && (
                                    <TableCell padding="none" align="center">
                                        {(p.messageJsonBL || p.messageJsonCommande || p.messageJsonDemandeTransfert) && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => this.handleOpenJsonDialog(e, p)}
                                                title="Voir les messages JSON"
                                            >
                                                <DataObjectIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                )}
                            </TableRow >
                        </TooltipOnCursor>
                    );

                }));
        } else {
            return (null);
        }
    }

    render() {
        const { classes, high, afterSearch, cacherTableResultat, afficheApplication, afficheJson, piecesGestion } = this.props;
        const {
            warningReclamationIds,
            warningLivraison,
            warningLivraisonMessage,
            warningCommandeLD,
            warningCommandeLDMessage,
            jsonDialogOpen,
            jsonDialogPiece } = this.state;

        if (cacherTableResultat && !afterSearch ) {
            return null;
        }

        return (
            <React.Fragment>

                <WarningReclamationDialog
                    warningReclamationIds={warningReclamationIds}
                    onWarningCancel={this.handleWarningCancel}
                    onIgnoreWarning={this.handleIgnoreWarning}
                />


                {/* Dialogue d'avertissement pour la livraison directe */}
                <Dialog open={warningCommandeLD && warningReclamationIds.length === 0}>
                    <DialogTitle>
                        <span>Attention commande livraison directe.</span>
                    </DialogTitle>
                    <DialogContent>
                        <span dangerouslySetInnerHTML={{ __html: warningCommandeLDMessage }} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleWarningCancel} color="primary" >Annuler</Button>
                        <Button
                            onClick={this.handleIgnoreWarningCommandeLivraisonDirecte}
                            variant="contained"
                            color="secondary"
                        >
                            Poursuivre
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={warningLivraison}>
                    <DialogTitle>
                        <span>Attention date de livraison récente.</span>
                    </DialogTitle>
                    <DialogContent>
                        <span dangerouslySetInnerHTML={{ __html: warningLivraisonMessage }} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleWarningCancel} color="primary" >Annuler</Button>
                        <Button
                            onClick={this.handleIgnoreWarningLivraison}
                            variant="contained"
                            color="secondary"
                        >
                            Poursuivre
                        </Button>
                    </DialogActions>
                </Dialog>


                <TableContainer sx={{ maxHeight: Math.min(300, 32*(4 + (piecesGestion ? piecesGestion.length : 0))) }}>
                    <Table stickyHeader aria-label="sticky table" sx={{ width: '100%' }} size='small'>
                        <TableHead
                            sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                            }}
                        >
                            <TableRow>
                                <TableCell sx={{ width: '190px' }}>Numéro pièce</TableCell>
                                <TableCell sx={{ width: '180px' }}>Numéro préparation</TableCell>
                                <TableCell sx={{ width: '180px' }}>Commande d'origine</TableCell>
                                <TableCell>Référence commande</TableCell>
                                <TableCell sx={{ width: '140px' }}>Dépôt de départ</TableCell>
                                <TableCell sx={{ width: '110px' }}>Nb articles</TableCell>
                                <TableCell>Transporteur</TableCell>
                                <TableCell sx={{ width: '140px' }}>Date expédition</TableCell>
                                <TableCell sx={{ width: '140px' }}>Date création</TableCell>
                                {afficheApplication && (<TableCell sx={{ width: '60px' }}>App</TableCell>)}
                                {afficheJson && (<TableCell sx={{ width: '50px' }}>JSON</TableCell>)}
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ minHeight: 64 }}>
                            {this.renderMessage()}
                            {this.renderRows()}
                        </TableBody>

                    </Table>
                </TableContainer>

                {afficheJson && jsonDialogPiece && (
                    <JsonViewerDialog
                        open={jsonDialogOpen}
                        onClose={this.handleCloseJsonDialog}
                        title={
                            <Table size="small" sx={{ width: 'auto' }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold', pl: 0 }}>Numéro pièce</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Numéro préparation</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Commande d'origine</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Référence commande</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ pl: 0 }}>{jsonDialogPiece.numeroPiece}</TableCell>
                                        <TableCell>{jsonDialogPiece.numeroPreparation}</TableCell>
                                        <TableCell>{jsonDialogPiece.commandeOrigine}</TableCell>
                                        <TableCell>{jsonDialogPiece.referenceCommande}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        }
                        jsonEntries={jsonDialogPiece.applicationOrigine
                            ? [
                                { label: 'Commande (BONFOUPHY)', value: jsonDialogPiece.messageJsonCommande, dateIntegration: jsonDialogPiece.dateIntegrationCommande, dateModification: jsonDialogPiece.dateDerniereMiseAJourCommande },
                                { label: 'Bon de Livraison (LIV)', value: jsonDialogPiece.messageJsonBL, dateIntegration: jsonDialogPiece.dateIntegrationBL, dateModification: jsonDialogPiece.dateDerniereMiseAJourBL },
                                { label: 'Demande de Transfert', value: jsonDialogPiece.messageJsonDemandeTransfert, dateIntegration: jsonDialogPiece.dateIntegrationDemandeTransfert, dateModification: jsonDialogPiece.dateDerniereMiseAJourDemandeTransfert },
                            ]
                            : [
                                { label: 'BONWEB', value: jsonDialogPiece.messageJsonCommande, dateIntegration: jsonDialogPiece.dateIntegrationCommande, dateModification: jsonDialogPiece.dateDerniereMiseAJourCommande },
                            ]
                        }
                    />
                )}

            </React.Fragment>
        );
    }
}

PieceGestionSearchResult.propTypes = {
    piecesGestion: PropTypes.array.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    afterSearch: PropTypes.bool.isRequired,
    high: PropTypes.bool,
    warningReclamation: PropTypes.bool.isRequired,
    warningCancel: PropTypes.func.isRequired,
    filterIMM30: PropTypes.bool,
    warningLivraison: PropTypes.bool.isRequired,
    disableToutesLignesNulles: PropTypes.bool,
    disableMixLignesPositivesNegatives: PropTypes.bool.isRequired,
};

PieceGestionSearchResult.defaultProps = {
    disableToutesLignesNulles: true
};


export default withStyles(styles)(React.memo(PieceGestionSearchResult));
